(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    function clarifyShabaOrderButtons() {
  document.querySelectorAll('.accelerated-checkout-block:has([data-shaba-order-label])').forEach((container) => {
    const label = container.querySelector('[data-shaba-order-label]').dataset.shabaOrderLabel;
    container.querySelectorAll('.es-popup-button-product').forEach((button) => {
      const brandStyles = {
        background: 'var(--shaba-order-button-bg, var(--shaba-red))',
        color: 'var(--shaba-cream)',
        'border-color': 'var(--shaba-red)',
        'border-radius': '12px'
      };
      for (const [property, value] of Object.entries(brandStyles)) {
        if (button.style.getPropertyValue(property) !== value || button.style.getPropertyPriority(property) !== 'important') {
          button.style.setProperty(property, value, 'important');
        }
      }
    });
    container.querySelectorAll('.es-popup-button-product .es-button-title').forEach((title) => {
      if (title.textContent !== label) title.textContent = label;
    });
  });
}
clarifyShabaOrderButtons();
const shabaOrderObserver = new MutationObserver(clarifyShabaOrderButtons);
shabaOrderObserver.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
  } catch(e) { console.error(e); }
})();

})();
